import type { RowClassRules } from 'ag-grid-community';
import type React from 'react';

import type { DEFAULT_ADD_RATIO_STEPS } from './constants';
import type { TTableFiltersProps, TTableFiltersState } from './types';

export const getItemDisabledDefault = (isDisabled?: boolean) => (item: (typeof DEFAULT_ADD_RATIO_STEPS)[number]) =>
    isDisabled && item?.stepId === 1;

export const getItemCompleted =
    (activeStep: (typeof DEFAULT_ADD_RATIO_STEPS)[number]) => (item: (typeof DEFAULT_ADD_RATIO_STEPS)[number]) =>
        item?.stepId < activeStep?.stepId;

export const getRowId = ({ data }: { data: any }) => data?.id?.toString();

export const getRowClass: RowClassRules = {
    groupRow: ({ data }: { data: { groupRow: boolean } }) => data?.groupRow,
};

export const changeTableFilterHandler =
    (setStateAction: React.Dispatch<React.SetStateAction<any>>) =>
    ({ fieldName, checkedValues }: TTableFiltersProps) => {
        setStateAction((prevFilters: TTableFiltersState) => ({
            ...prevFilters,
            [fieldName]: checkedValues,
        }));
    };

export const getWhereColumnFilters = (filters: Record<string, string[]>) =>
    Object.keys(filters).reduce((where: any, fieldName: string) => {
        const checkedValues = filters[fieldName];

        if (checkedValues?.length) {
            where[fieldName] = {
                or: checkedValues.map((item: string) => ({
                    eq: item,
                })),
            };
        }

        return where;
    }, {});
